import React from "react";
import NumberFormat from "react-number-format";

interface IProps {
  value: number | string;
  className?: string;
}

const CurrencyFormat = ({ value, className }: IProps) => {
  return (
    <NumberFormat
      value={value && Number(value)}
      className={className ?? "foo"}
      displayType={"text"}
      thousandSeparator={true}
      prefix={"$"}
    />
  );
};
export default CurrencyFormat;
